import * as actionTypes from './actionTypes';

export const mapDisabilityNextStep = () => {
  return {
    type : actionTypes.MAP_DISABILITY_NEXT_STEP,
    val : null
  }
}

export const mapDisabilityGoBack = () => {
  return {
    type : actionTypes.MAP_DISABILITY_PREVIOUS_STEP,
    val : null
  }
}

export const mapDisabilityUploadFileSuccess = (columns, data, file) => {
  console.log(columns, data, file)
  return {
    type : actionTypes.MAP_DISABILITY_UPLOAD_FILE_SUCCESS,
    val : {
      columns : columns,
      data : data,
      file: file
    }
  }
}

export const mapDisabilityMatchColumnSuccess = (val) => {
  return {
    type : actionTypes.MAP_DISABILITY_MATCH_COLUMN_SUCCESS,
    val : val
  }
}

export const saveAllDisabilityMapping = (val) => {
  return {
    type : actionTypes.MAP_DISABILITY_SAVE_DISABILITY_MAPPING,
    val : val
  }
}

export const resetDisability = () => {
  return {
    type : actionTypes.MAP_DISABILITY_RESET,
    val : null
  }
}

export const resetMapDisabilityStep = () => {
  return {
    type : actionTypes.MAP_DISABILITY_RESET_STEP,
    val : null
  }
}
